import { render, staticRenderFns } from "./Dealt.vue?vue&type=template&id=5f2b676c&scoped=true"
import script from "./Dealt.vue?vue&type=script&lang=js"
export * from "./Dealt.vue?vue&type=script&lang=js"
import style0 from "./Dealt.vue?vue&type=style&index=0&id=5f2b676c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2b676c",
  null
  
)

export default component.exports